import { Component, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';

@Component({
  selector: 'form-button',
  styleUrls: ['form-button.component.scss'],
  template: `
    <div
      *ngIf="typeCes !== typeCesEnum.SHOW"
      class="dynamic-field form-button"
      [formGroup]="group"
      align="end"
    >
      <button
        mat-raised-button
        cdkFocusInitial
        [disabled]="config.disabled"
        type="submit"
      >
        {{ config.label }}
      </button>
    </div>
  `,
})
export class FormButtonComponent implements Field {
  config: IFieldConfig;
  group: FormGroup;
  typeCes?: TypeCesEnum | undefined;

  get typeCesEnum() {
    return TypeCesEnum;
  }
}
